import React from "react";
import HelpMessage from 'components/util/helpers/HelpMessage';
import l from "components/util/l";

const HeaderItem = ({
  name,
  label,
  icon,
  iconStyle,
  activeSection,
  isDropdownItem,
  isPinned,
  onClickItem,
  onClickPinView
}) => (
  <HelpMessage message={l(label)}
    style={{
      marginTop: "-12px", maxWidth: "14rem",
      ...name == activeSection.name || !isPinned ? { display: "none" } : {}
    }}>
    <button type="button"
      className={`btn menu-item d-flex align-items-center ` +
        (name == activeSection.name ? "active " : " ")
        + (isPinned && !isDropdownItem ? "pinned " : " ")
      }
      onClick={() => onClickItem(name)}
    >
      <div className="d-flex align-items-center w-100">
        <i className={icon} style={iconStyle}></i>
        <label className="w-100 text-truncate text-left ml-2">{l(label)}</label>
      </div>
      {isDropdownItem &&
        <button
          type="button"
          className={`btn btn-pin m-0 p-0 pl-1 pr-0 mt-n1 ${isPinned ? "pinned" : ""}`}
          onClick={(e) => {
            e.stopPropagation();
            onClickPinView(name);
          }}
        >
          <span className="d-none d-sm-block fa-stack">
            <i className={`fas fa-stack fa-thumbtack`}></i>
            {
              isPinned
                ? null
                : <i className="fas fa-slash fa-stack-1x"></i>
            }
          </span>

        </button>}
    </button>
  </HelpMessage>

);

export default HeaderItem;
